var _excluded = ["currency", "enableFreeDomesticDeliveryLabels", "hideLabelIcons", "lazyImages", "onNavigation", "onProductClick", "onVisible", "products"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { Carousel } from "../../internal/Carousel/Carousel";
import { CarouselItem } from "../../internal/Carousel/CarouselItem";
import { CarouselProductCard } from "../Cards/CarouselProductCard/components/CarouselProductCard";
import { ProductCarouselSkeleton } from "../ProductCarouselSkeleton/ProductCarouselSkeleton";
import { useGridColumnGap } from "../../../hooks/useGridColumnGap";
export var PRODUCT_CAROUSEL_TEST_ID = 'product-carousel';
export var ProductCarousel = function ProductCarousel(_ref) {
  var currency = _ref.currency,
    enableFreeDomesticDeliveryLabels = _ref.enableFreeDomesticDeliveryLabels,
    hideLabelIcons = _ref.hideLabelIcons,
    lazyImages = _ref.lazyImages,
    onNavigation = _ref.onNavigation,
    onProductClick = _ref.onProductClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    products = _ref.products,
    carouselProps = _objectWithoutProperties(_ref, _excluded);
  var columnGap = useGridColumnGap();
  var observedElementRef = useImpressionRef(function () {
    return onVisible();
  });
  return products === null ? /*#__PURE__*/React.createElement(ProductCarouselSkeleton, null) : /*#__PURE__*/React.createElement("div", {
    "data-testid": PRODUCT_CAROUSEL_TEST_ID,
    ref: observedElementRef
  }, /*#__PURE__*/React.createElement(Carousel, _extends({
    columnGap: columnGap,
    onNavigateLeft: function onNavigateLeft(_ref2) {
      var swiped = _ref2.swiped;
      return onNavigation === null || onNavigation === void 0 ? void 0 : onNavigation(swiped, 'prev');
    },
    onNavigateRight: function onNavigateRight(_ref3) {
      var swiped = _ref3.swiped;
      return onNavigation === null || onNavigation === void 0 ? void 0 : onNavigation(swiped, 'next');
    },
    titleSize: "regular"
  }, carouselProps), products.map(function (product, index) {
    var _product$isNew, _product$isPurchasabl, _product$salePercenta;
    return /*#__PURE__*/React.createElement(CarouselItem, {
      ariaLabel: "slide ".concat(index + 1, " of ").concat(products.length),
      key: product.title
    }, /*#__PURE__*/React.createElement(CarouselProductCard, {
      alt: product.alt,
      currency: currency,
      enableFreeDomesticDeliveryLabels: enableFreeDomesticDeliveryLabels,
      freeDomesticDelivery: product.freeDomesticDelivery,
      hideLabelIcons: hideLabelIcons,
      href: product.href,
      imageLoading: lazyImages ? 'lazy' : 'eager',
      isNew: (_product$isNew = product.isNew) !== null && _product$isNew !== void 0 ? _product$isNew : false,
      linkDataAttributes: product.trackingURL ? {
        'tracking-url': product.trackingURL
      } : {},
      onLinkClick: function onLinkClick(e) {
        onProductClick === null || onProductClick === void 0 || onProductClick(e, {
          index
        });
      },
      preSalePrice: product.preSalePrice,
      price: product.price,
      purchasable: (_product$isPurchasabl = product.isPurchasable) !== null && _product$isPurchasabl !== void 0 ? _product$isPurchasabl : false,
      salePercentage: (_product$salePercenta = product.salePercentage) !== null && _product$salePercenta !== void 0 ? _product$salePercenta : undefined,
      src: product.src,
      title: product.title
    }));
  })));
};